import { getAccountScopeUserSettings } from "owa-session-store";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { owaDate, differenceInDays } from "owa-datetime";
import type { OwaDate } from "owa-datetime";

const NUM_DAYS_TWO_WEEKS = 14;
const NUM_DAYS_SIX_WEEKS = 42;

function getEmbedChatLastUsedDate(): OwaDate | null {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    
    const primeSettings = getAccountScopeUserSettings(mailboxInfo)?.PrimeSettings;
    const embedChatLastUsedDate = primeSettings?.Items?.filter(item => item.Id === "TeamsEmbedChatOptions").map(item => item.Value?.options?.[0].embedChatLastUsedDate)[0];
    
    return embedChatLastUsedDate ? owaDate("UTC", embedChatLastUsedDate) : null;
}

function isWithinDays(lastUsed: OwaDate, daysThreshold: number): boolean {
    return differenceInDays(owaDate("UTC"), lastUsed) <= daysThreshold;
}

export function shouldLoadEmbedPreAuthOnIdle(): boolean {
    const lastUsed = getEmbedChatLastUsedDate();
    return !!lastUsed && isWithinDays(lastUsed, NUM_DAYS_TWO_WEEKS);
}

export function shouldMakeCallToGetChatUnreadMessageCount(): boolean {
    const lastUsed = getEmbedChatLastUsedDate();
    return !!lastUsed && isWithinDays(lastUsed, NUM_DAYS_SIX_WEEKS);
}
